import * as React from 'react';
import { useHistory, useLocation } from 'react-router';
import { ROUTE_PATH } from '../../routes/paths';
import Heading from './heading';
import { Link } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { useClientsWithPackages } from '../../hooks/useClients';

type props = {
  heading: String;
  childArray: [];
};

const SideBarChild: React.FunctionComponent<props> = ({ heading, childArray }): JSX.Element => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { data: clientsWithPackages } = useClientsWithPackages();

  let hideEligibilty = true;
  if (clientsWithPackages && clientsWithPackages?.length > 0) {
    const verifyEligibility = clientsWithPackages.every(
      (item: any) => !!item.eligibility_config?.hide_client_admin_eligibility,
    );
    hideEligibilty = !!verifyEligibility;
    if (!!(verifyEligibility && pathname === ROUTE_PATH.ELIGIBILTY)) {
      history.push(ROUTE_PATH.SNAPSHOT);
    }
  }

  return (
    <div>
      {heading.length > 1 && <Heading heading={heading} />}
      <div className="relative">
        {childArray &&
          childArray.map((item: any) => {
            const pathMatches =
              pathname === item.path || (item.path !== pathname && pathname.startsWith(item.path + '/'));
            const longerMatchExists = childArray.some(
              (other: any) =>
                other.path !== item.path &&
                other.path.length > item.path.length &&
                (pathname === other.path || pathname.startsWith(other.path + '/')),
            );
            const selected = pathMatches && !longerMatchExists;
            if (!(hideEligibilty && item.text === 'Eligibility')) {
              return (
                <Link to={item.path}>
                  <div
                    key={item.path}
                    role="button"
                    className={`w-12/12 relative flex py-2 pl-7 ${selected ? 'btn-blue text-white' : 'text-gray-dark'}`}
                    data-testid={`${item.text}-tab`}
                  >
                    <button className={'text-center text-base font-bold'}>{item.text}</button>
                  </div>
                </Link>
              );
            }
          })}
      </div>
    </div>
  );
};

export default SideBarChild;
